const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager report component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerUser', ['Application', 'Authorization', 'Users', 'AnalyzeManager', '$translate', function (Application, Authorization, Users, AnalyzeManager, $translate) {
  return {
    restrict: 'E',
    scope: {
      tab: '=',
      manager: '=',
      singleUser: '=',
      managerConfiguration: '=?'
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-user.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.features = Application.features.flags();
      self.journeysEnabled = Application.features.journeys();
      self.editing = {
        referenceUser: {},
        showEdit: false,
        canEdit: $scope.managerConfiguration && $scope.managerConfiguration.allow_user_edit,
        canResetPassword: $scope.managerConfiguration && $scope.managerConfiguration.allow_password_reset,
        startEdit: function() {
          self.editing.referenceUser = {};
          self.editing.showEdit = true;
        },
        onClose: function(results) {
          if (results) {
            if (results.results && results.results.first_name && results.results.last_name) {
              self.information.user.full_name = results.results.first_name + ' ' + results.results.last_name;
            }
          }
          self.editing.showEdit = false;
        }
      };

      self.email = {
        resetEmailSent: false,
        sendResetEmail: function () {
          var domain = Application.companyDomain;

          Users.singleresetting({subresource: self.information.user.email}, {domain: domain},
              function (res) {
                Application.messaging.addMessage({
                  type: 'success',
                  text: self.translations['userManager.reset_email_sent'],
                  duration: 5
                });
                self.email.resetEmailSent = true;
              },
              function (err) {
                Application.messaging.addMessage({
                  type: 'information',
                  text: self.translations['userManager.reset_email_error'],
                  duration: 15
                })
              }
          )
        }
      }


      self.information = {
        user: null,
        innerTab: 'assignments',
        get: function(text) {

          Users.get({subresource: $scope.singleUser, fields: 'first_name,last_name,email,full_name,is_manager,last_login,manager_email'}).$promise
          .then(function(result) {
            self.information.user = result;
            self.circles.user_list = [self.information.user._id];
            self.circles.get();
            self.circles.last_login = moment().diff(moment(result.last_login), 'days');
          });
        },
      };

      self.circles = {
        last_login: '--',
        date_since: moment().date(1).month(0).format("MMM YYYY"),
        likes: 0,
        shares: 0,
        sessions: 0,
        user_list: [],
        get: function() {
          var date = moment().date(1).month(0).format("MM-DD-YYYY");
          AnalyzeManager.user({itemid: $scope.singleUser, fourth: date}).$promise
          .then(function(data) {
            self.circles.likes = data.likes;
            self.circles.shares = data.shares;
            self.circles.sessions = data.sessions;
          });
        }
      };

      self.changeManager = function() {
        $scope.manager = self.information.user;
        $scope.tab = 'users';
      };

      self.back = function() {
        $scope.tab = 'users';
      };

      $scope.$watch('singleUser', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          self.information.get();
          self.csvLink = Application.API + '/learn/v3/managers/' + $scope.singleUser + '/user-report' + '?authtoken=' + Authorization.getAuthToken().authtoken
        }
      });

      $translate([
        'smartbar.placeholder.content',
        'managerUser.days',
        'managerUser.since_user_logged_in',
        'managerUser.sessions',
        'managerUser.since_date',
        'managerUser.lies',
        'managerUser.shares',
        'userManager.reset_email_sent',
        'userManager.reset_email_error'
      ]).then(function(translations){
        self.translations = translations;
        if ($scope.singleUser) {
          self.information.get();
          self.csvLink = Application.API + '/learn/v3/managers/' + $scope.singleUser + '/user-report' + '?authtoken=' + Authorization.getAuthToken().authtoken
        }
      });

      self.circlestatTranslations = {};

      $translate('managerUser.since_date', {  date : self.circles.date_since }).then(function (translation) {
        self.circlestatTranslations['since_date'] = translation;
      });

    }],
    controllerAs: 'report'
  };
}]);
